import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useContext } from 'react';
import { FileUploaderViaFirebaseStorage, FirebaseAppContext } from 'libs.firebase_react';
import { useLocalizeMessage } from 'libs.nucleus';
import { useImportState } from './contexts/import_state.context';
export const UploadNonMedableFiles = ({ assetId }) => {
    const translate = useLocalizeMessage();
    const { logEvent } = useContext(FirebaseAppContext);
    const { setFiles, setFilesLoading, setFilesLoaded } = useImportState();
    const handleFileChange = useCallback((files) => {
        const fileTypeCounts = Object.values(files).reduce((acc, { file }) => {
            const ext = file.name.split('.').pop();
            if (ext) {
                acc[ext] = (acc[ext] || 0) + 1;
            }
            return acc;
        }, {});
        logEvent('import_with_ai_upload_files', {
            assetId,
            fileTypeCounts,
        });
        setFiles(files);
    }, [setFiles, assetId, logEvent]);
    const handleFilesLoading = useCallback(() => {
        setFilesLoading();
    }, [setFilesLoading]);
    const handleFilesLoaded = useCallback(() => {
        setFilesLoaded();
    }, [setFilesLoaded]);
    return (_jsx("div", { className: 'flex justify-center p-4', children: _jsx(FileUploaderViaFirebaseStorage, { storageBaseUrl: 'uploads/import_v2', label: translate('Selected documents will be imported using Medable AI.'), accept: '.doc,.docx,.xlsx,.json,.pdf', multiple: true, onFileChange: handleFileChange, description: translate('Upload individual or multiple files using the following formats: .doc, .docx, .xlsx, .json, .pdf'), buttonLabel: translate('Upload'), onLoaded: handleFilesLoaded, onSetFiles: handleFilesLoading }) }));
};
